export default class BilledStore {
  name: string;
  cost: number;
  maximumDevices: number;

  constructor(name: string = "", cost: number = 0, maximumDevices: number = 0) {
    this.name = name;
    this.cost = cost;
    this.maximumDevices = maximumDevices;
  }

  public static fromJson(x: any) {
    console.log(x);
    return new BilledStore(x.name, x.cost, x.maximumDevices);
  }
}
